'use client';
import React from 'react';
import { Link as MaterialLink, LinkProps as MaterialLinkProps } from '@mui/material';
import { RouterLink } from '@peerless/ui-locale';

export type LinkProps = Omit<MaterialLinkProps<typeof RouterLink>, 'ref'>;

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <MaterialLink ref={ref} component={RouterLink} {...props} />
));
